<template>
  <div class="filter-container">
    <el-card>
      <el-input
        v-model="value.activity_id"
        class="filter-item"
        style="width: 150px"
        clearable
        placeholder="请输入活动ID"
      ></el-input>
      <el-input
        v-model="value.name"
        class="filter-item"
        style="width: 150px"
        clearable
        placeholder="请输入活动名称"
      ></el-input>
      <el-input
        v-model="value.productKeyword"
        class="filter-item"
        style="width: 150px"
        clearable
        placeholder="请输入课程ID或课程名称"
      ></el-input>
      <el-select
        style="width: 150px"
        class="filter-item"
        v-model="value.year"
        clearable
        placeholder="适用年份"
      >
        <el-option :key="2025" label="2025" :value="2025"></el-option>
        <el-option :key="2026" label="2026" :value="2026"></el-option>
        <el-option :key="2027" label="2027" :value="2027"></el-option>
        <el-option :key="2028" label="2028" :value="2028"></el-option>
        <el-option :key="2029" label="2029" :value="2029"></el-option>
      </el-select>
      <CourseCascader v-model="value.proSysNum"></CourseCascader>
      <el-select
        style="width: 150px"
        class="filter-item"
        v-model="value.hasBind"
        clearable
        placeholder="是否绑定"
      >
        <el-option :key="true" label="是" :value="true"></el-option>
        <el-option :key="false" label="否" :value="false"></el-option>
      </el-select>
      <!-- 创建人 -->
      <RemoteSelect v-model="value.creator" />
      <el-select
        style="width: 150px"
        class="filter-item"
        v-model="value.hasEnable"
        clearable
        placeholder="是否有效"
      >
        <el-option :key="true" label="是" :value="true"></el-option>
        <el-option :key="false" label="否" :value="false"></el-option>
      </el-select>
      <el-date-picker
        v-model="dateTimeRange"
        type="datetimerange"
        range-separator="至"
        start-placeholder="开始时间"
        end-placeholder="结束日期"
        :default-time="defaultTime"
        value-format="yyyy-MM-dd HH:mm:ss"
        clearable
        style="margin: 0 10px 10px 0; vertical-align: middle"
        @change="formatDataTime"
      ></el-date-picker>
      <el-button class="filter-item" type="primary" icon="el-icon-search" @click="doSearch"
        >搜索</el-button
      >
    </el-card>
  </div>
</template>

<script>
import _ from "lodash-es";
import RemoteSelect from "@/components/RemoteSelect";
import CourseCascader from "./CourseCascader";
export default {
  components: {
    RemoteSelect,
    CourseCascader,
  },
  props: {
    value: {
      type: Object,
      default: () => {
        return {};
      },
    },
  },
  data() {
    return {
      dateTimeRange: [],
      defaultTime: ["00:00:00", "23:59:59"],
      proSysNumList: [],
    };
  },
  created() {
    const { query } = this.$route;
    const { page, size, hasEnable, ...rest } = query;
    this.$emit("input", {
      ...rest,
      page: parseInt(page) || 1,
      size: parseInt(size) || 10,
      hasEnable: hasEnable === undefined ? undefined : Boolean(hasEnable),
    });
    console.log(query);
    this.dateTimeRange = [rest.startTime, rest.endTime];
  },
  methods: {
    doSearch() {
      const { path } = this.$route;
      this.$router
        .replace({
          path,
          query: _.omitBy({ ...this.value }, (value) => ["", undefined, null].includes(value)),
        })
        .catch(() => {});
      this.$emit("search");
    },
    formatDataTime(v) {
      if (v) {
        this.value.startTime = this.dateTimeRange[0];
        this.value.endTime = this.dateTimeRange[1];
      } else {
        this.value.startTime = "";
        this.value.endTime = "";
      }
    },
  },
};
</script>

<style></style>
